import { render } from "./documentEmail.vue?vue&type=template&id=de7f0408"
import script from "./documentEmail.vue?vue&type=script&lang=js"
export * from "./documentEmail.vue?vue&type=script&lang=js"

import "./documentEmail.vue?vue&type=style&index=0&id=de7f0408&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__